import interact from 'interactjs';

export function initDropzone(selector, $bus, isDefault, callback) {
  interact(selector).dropzone({
    // event.target -- dropzone
    // event.relatedTarget -- draggable Item
    accept: '.drag-drop',
    overlap: 0.75,
    checker: function(dragEvent, event, dropped, dropzone, dropElement, draggable, draggableElement) {
      return dropped && !dropElement.hasChildNodes();
    },
    ondropactivate: function(event) {},
    ondragenter: function(event) {
      var draggableElement = event.relatedTarget;
      var dropzoneElement = event.target;
    },
    ondragleave: function(event) {
      var draggableElement = event.relatedTarget;
      var dropzoneElement = event.target;
    },
    ondrop: function(event) {
      console.log(event);
      const { dragEvent, relatedTarget } = event;
      const dropzone = $bus.$refs.refDropzone;
      const newScene = relatedTarget.cloneNode();

      // relatedTarget.remove();

      if (![ ...newScene.classList ].includes('is-appended')) {
        relatedTarget.remove();

        //   newScene.style = 'transform: none; cursor: move;';
        //   newScene.setAttribute('data-x', '0');
        //   newScene.setAttribute('data-y', '0');
        //   newScene.classList.add('is-appended');
      }

      // dropzone.appendChild(newScene);
    },
    ondropdeactivate: function(event) {
      // remove active dropzone feedback
      // console.log("[event] ondropSdeactivate", event);
      event.target.classList.remove('drop-active');
      event.target.classList.remove('drop-target');
    },
  });
}

export function initDraggable(item, onEnd) {
  interact(item).draggable({
    inertia: false,
    restrict: {
      drag: '.default-dropzone',
    },
    onmove: function(event) {
      const target = event.target;
      const { height, width } = target.parentElement.getBoundingClientRect();

      const x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
      const y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;

      const xPercentage = 100 * (x / width);
      const yPercentage = 100 * (y / height);

      // console.log('x = ', x);
      // console.log('y = ', y);
      // console.log('xPercentage = ', xPercentage);
      // console.log('yPercentage = ', yPercentage);

      target.style.left = `${xPercentage}%`;
      target.style.top = `${yPercentage}%`;
      target.setAttribute('data-x', x);
      target.setAttribute('data-y', y);
    },
    onend: function(event) {
      onEnd(event);
    },
  });
}

export const getProjectScenes = (project) => {
  const scenes = project.scenes.filter((scene) => scene.type === 'scene');
  const home = project.scenes.find((scene) => scene.type === 'home');
  const subscenes = project.scenes
    .filter((scene) => scene.subscenes && scene.subscenes.length)
    .map((scenes) => {
      return { subscenes: scenes.subscenes, _id: scenes._id };
    })
    .map((subscenesObj) => {
      return subscenesObj.subscenes.map((subscene, i) => {
        subscene.index = i;
        subscene.parentId = `${subscenesObj._id}`;

        return subscene;
      });
    });

  const result = [ home, ...scenes, ...subscenes.flat() ];

  return result;
};
